module.exports = __webpack_public_path__ + "static/img/want.9a67234.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/want.png
// module id = w/BQ
// module chunks = 0